/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const scroll_chain_about = () => `Scroll, a Layer 2 Ethereum network, aims to simplify scaling solutions for projects utilizing the Ethereum Virtual Machine (EVM). Its primary mechanism, zkEVM, integrates zero-knowledge proofs with the EVM, enabling rapid Ethereum transaction confirmation without the need to store and transfer additional transaction data. Scroll aims to establish a universal network that grants developers a user experience and security level akin to Ethereum while surpassing Ethereum in throughput, verification speed, and gas fee affordability`
